export default __webpack_public_path__ + "72ca924f30830dc7b3ce86ab02ce8c66.png";